import { render, staticRenderFns } from "./MarathonPopup.vue?vue&type=template&id=fdde1b40&scoped=true&"
import script from "./MarathonPopup.vue?vue&type=script&lang=js&"
export * from "./MarathonPopup.vue?vue&type=script&lang=js&"
import style0 from "./MarathonPopup.vue?vue&type=style&index=0&id=fdde1b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdde1b40",
  null
  
)

export default component.exports